export default __webpack_public_path__ + "static/media/aboutus-4.c297aa30.jpg";